import { useState } from "react";

/**
 * Manages an editable field with edit/save/cancel workflow.
 * Resets to the original value when the source changes.
 */
export function useEditableField(original: string) {
  const [value, setValue] = useState(original);
  const [editing, setEditing] = useState(false);

  function startEditing() {
    setValue(original);
    setEditing(true);
  }

  function cancel() {
    setValue(original);
    setEditing(false);
  }

  function done() {
    setEditing(false);
  }

  return {
    value,
    setValue,
    editing,
    startEditing,
    cancel,
    done,
  };
}
